import React from "react";
import { Link } from "react-router-dom";

// Datos de contacto de Caprim. Si cambia alguno, se edita aqui y ya.
const TELEFONO_VISIBLE = "+57 302 560 7764";
const TELEFONO_ENLACE = "tel:+573025607764";
const WHATSAPP_ENLACE =
    "https://wa.me/573025607764?text=Hola,%20quiero%20conocer%20m%C3%A1s%20sobre%20los%20servicios%20de%20Caprim";
const CORREO = "gerencia@caprimtech.com";

const canales = [
    {
        icono: "fa-solid fa-phone",
        titulo: "Teléfono",
        detalle: TELEFONO_VISIBLE,
        enlace: TELEFONO_ENLACE,
    },
    {
        icono: "fa-brands fa-whatsapp",
        titulo: "WhatsApp",
        detalle: "Escríbenos y te respondemos",
        enlace: WHATSAPP_ENLACE,
    },
    {
        icono: "fa-regular fa-envelope",
        titulo: "Correo",
        detalle: CORREO,
        enlace: `mailto:${CORREO}`,
    },
    {
        icono: "fa-regular fa-clock",
        titulo: "Horario de atención",
        detalle: "Lunes a viernes 8:00 – 18:00 · Sábados 8:00 – 12:00",
        enlace: null,
    },
];

const Aboutthree = () => {
    return (
        <>
            <div className="contact-section">
                <div className="container">
                    <div className="heading-box text-center">
                        <span className="heading-subtitle wow fadeInUp animated animated">
                            🤝 CONTÁCTANOS
                        </span>
                        <h2 className="heading-title wow fadeInUp animated animated">
                            Canales de atención
                        </h2>
                    </div>
                    <div className="row gutter-y-30">
                        {canales.map((canal, i) => (
                            <div className="col-lg-3 col-md-6" key={i}>
                                <div className="contact-location">
                                    <i
                                        className={canal.icono}
                                        style={{ fontSize: "26px", marginRight: "12px" }}
                                    />
                                    <h5>{canal.titulo}</h5>
                                </div>
                                <p>
                                    {canal.enlace ? (
                                        <Link to={canal.enlace}>{canal.detalle}</Link>
                                    ) : (
                                        canal.detalle
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};
export default Aboutthree;
